<div class="sw-field">
    <div class="sw-field__label">{{ label }}</div>
</div>
<sw-price-field
    :value="price"
    :taxRate="tax"
    :currency="currency"
    @change="priceChanged"
/>